(function () {
  'use strict';
  var MOUNT_ID = 'bundle-builder';
  var CONFIG_ID = 'bundle-builder-config';
  var root, cfg, state = { tier: 0, picks: [], addons: {} };
  function money(cents) {
    var c = Math.round(cents);
    return cfg.moneyFormat
      ? cfg.moneyFormat.replace('{{amount}}', (c / 100).toFixed(2))
      : '$' + (c / 100).toFixed(2);
  }
  function tier() { return cfg.tiers[state.tier]; }
  function total() {
    var sum = tier().price;
    (cfg.addons || []).forEach(function (a) { if (state.addons[a.id]) sum += a.price; });
    return sum;
  }
  function unitOptions(selected) {
    return cfg.variants.map(function (v) {
      return '<option value="' + v.id + '"' +
        (String(v.id) === String(selected) ? ' selected' : '') +
        (v.available ? '' : ' disabled') + '>' +
        v.title + (v.available ? '' : ' — sold out') + '</option>';
    }).join('');
  }
  function render() {
    var html = '';
    if (cfg.label) html += '<p class="bbdl__label">' + cfg.label + '</p>';
    cfg.tiers.forEach(function (tr, i) {
      var on = i === state.tier;
      html += '<div class="bbdl__tier' + (on ? ' is-on' : '') + '" data-tier="' + i + '">';
      html += '<label class="bbdl__head">';
      html += '<input type="radio" class="bbdl__radio" name="bbdl-tier" value="' + i + '"' + (on ? ' checked' : '') + '>';
      html += '<span class="bbdl__ht"><span class="bbdl__title">' + tr.title + '</span>';
      if (tr.subtitle) html += '<span class="bbdl__sub">' + tr.subtitle + '</span>';
      html += '</span>';
      html += '<span class="bbdl__pr"><span class="bbdl__price">' + money(tr.price) + '</span>';
      if (tr.compareAt && tr.compareAt > tr.price) html += '<span class="bbdl__was">' + money(tr.compareAt) + '</span>';
      html += '</span></label>';
      html += '<div class="bbdl__body">';
      if (cfg.variants.length > 1) {
        for (var u = 0; u < tr.qty; u++) {
          html += '<div class="bbdl__pick">';
          html += '<div class="bbdl__pickLabel">' +
            (tr.qty > 1 ? (cfg.unitWord || 'Item') + ' ' + (u + 1) : (cfg.pickLabel || 'Choose')) +
            '</div>';
          html += '<select class="bbdl__select" data-unit="' + u + '">' + unitOptions(state.picks[u]) + '</select>';
          html += '</div>';
        }
      }
      if (cfg.addons && cfg.addons.length) {
        html += '<div class="bbdl__addons">';
        cfg.addons.forEach(function (a) {
          html += '<label class="bbdl__addon">';
          html += '<input type="checkbox" class="bbdl__cb" data-addon="' + a.id + '"' +
            (state.addons[a.id] ? ' checked' : '') + '>';
          if (a.image) html += '<img class="bbdl__thumb" src="' + a.image + '" alt="" loading="lazy">';
          html += '<span class="bbdl__an">+ ' + a.title + '</span>';
          html += '<span class="bbdl__ap">' + money(a.price);
          if (a.compareAt && a.compareAt > a.price) html += '<s>' + money(a.compareAt) + '</s>';
          html += '</span></label>';
        });
        html += '</div>';
      }
      html += '</div></div>';
    });
    html += '<div class="bbdl__total"><span>' + (cfg.totalLabel || 'Total') + '</span><b data-total></b></div>';
    html += '<button type="button" class="bbdl__cta">' + (cfg.ctaLabel || 'Add to cart') + '</button>';
    html += '<p class="bbdl__err">' + (cfg.errorText || 'Please choose an option for every item.') + '</p>';
    root.innerHTML = html;
    paintTotal();
  }
  function paintTotal() {
    var el = root.querySelector('[data-total]');
    if (el) el.textContent = money(total());
  }
  function ready() {
    if (cfg.variants.length <= 1) return true;
    var t = tier();
    for (var i = 0; i < t.qty; i++) if (!state.picks[i]) return false;
    return true;
  }
  function onChange(e) {
    var el = e.target;
    if (el.name === 'bbdl-tier') { state.tier = parseInt(el.value, 10); render(); return; }
    if (el.hasAttribute('data-unit')) { state.picks[parseInt(el.getAttribute('data-unit'), 10)] = el.value; root.classList.remove('has-error'); return; }
    if (el.hasAttribute('data-addon')) { state.addons[el.getAttribute('data-addon')] = el.checked; paintTotal(); }
  }
  function addToCart() {
    var btn = root.querySelector('.bbdl__cta');
    if (!ready()) { root.classList.add('has-error'); return; }
    root.classList.remove('has-error');
    btn.disabled = true;
    var t = tier(), items = [], counts = {};
    if (cfg.variants.length > 1) {
      for (var i = 0; i < t.qty; i++) counts[state.picks[i]] = (counts[state.picks[i]] || 0) + 1;
    } else {
      counts[cfg.variants[0].id] = t.qty;
    }
    Object.keys(counts).forEach(function (id) { items.push({ id: Number(id), quantity: counts[id] }); });
    (cfg.addons || []).forEach(function (a) { if (state.addons[a.id]) items.push({ id: Number(a.id), quantity: 1 }); });
    fetch(cfg.routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json(); })
      .then(function () { window.location.href = cfg.afterAdd === 'cart' ? cfg.routes.cart : cfg.routes.checkout; })
      .catch(function () { btn.disabled = false; root.classList.add('has-error'); });
  }
  function boot() {
    root = document.getElementById(MOUNT_ID);
    var node = document.getElementById(CONFIG_ID);
    if (!root || !node) return;
    try { cfg = JSON.parse(node.textContent); } catch (e) { return; }
    if (!cfg.tiers || !cfg.tiers.length) return;
    if (!cfg.variants || !cfg.variants.length) return;
    var first = cfg.variants.filter(function (v) { return v.available; })[0] || cfg.variants[0];
    var maxQty = cfg.tiers.reduce(function (m, t) { return Math.max(m, t.qty); }, 1);
    state.picks = new Array(maxQty).fill(first.id);
    (cfg.addons || []).forEach(function (a) { state.addons[a.id] = !!a.checked; });
    root.classList.add('bbdl');
    render();
    root.addEventListener('change', onChange);
    root.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.bbdl__cta')) addToCart(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();


/* ── Minimum Order Amount ($29.95) ─────────────────────────────────── */
(function() {
  const MIN_CENTS = 2995; // $29.95
  const MSG = 'Add a StripSafe pack to unlock checkout (minimum order $29.95)';

  function injectMinOrderMsg() {
    if (document.getElementById('ssb-min-order-msg')) return;
    const btn = document.querySelector('.cart__checkout-button');
    if (!btn) return;
    const el = document.createElement('p');
    el.id = 'ssb-min-order-msg';
    el.style.cssText = 'display:none;margin:8px 0 0;font-size:13px;color:#D92D20;text-align:center;font-weight:500;';
    el.textContent = MSG;
    btn.parentNode.insertBefore(el, btn.nextSibling);
  }

  function enforceMinOrder() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const btn = document.querySelector('.cart__checkout-button');
        const msg = document.getElementById('ssb-min-order-msg');
        if (!btn) return;
        injectMinOrderMsg();
        const msgEl = document.getElementById('ssb-min-order-msg');
        if (cart.total_price < MIN_CENTS) {
          btn.setAttribute('disabled', 'disabled');
          btn.style.opacity = '0.5';
          btn.style.cursor = 'not-allowed';
          if (msgEl) msgEl.style.display = 'block';
        } else {
          btn.removeAttribute('disabled');
          btn.style.opacity = '';
          btn.style.cursor = '';
          if (msgEl) msgEl.style.display = 'none';
        }
      });
  }

  // Run on drawer open and cart updates
  document.addEventListener('cart:open', enforceMinOrder);
  document.addEventListener('cart:updated', enforceMinOrder);
  document.addEventListener('cartupdate', enforceMinOrder);

  // Observe DOM for drawer opening (theme may not fire custom events)
  const observer = new MutationObserver(() => {
    const drawer = document.querySelector('cart-drawer');
    if (drawer && drawer.classList.contains('is-open') || 
        document.querySelector('.drawer.active')) {
      enforceMinOrder();
    }
  });
  observer.observe(document.body, { attributes: true, subtree: true, attributeFilter: ['class'] });

  // Also run on page load in case cart is open
  document.addEventListener('DOMContentLoaded', enforceMinOrder);
})();
